import ContentBlock from './ContentBlock';

export default ContentBlock;
